export default function IconOpenEye() {
    return (
        <svg viewBox="0 0 489 490" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="eye" clipPath="url(#clip0_267_655)">
                <g id="Group">
                    <path id="Vector" d="M244.425 99.2266C151.025 99.2266 66.325 150.327 3.825 233.327C-1.275 240.127 -1.275 249.627 3.825 256.427C66.325 339.527 151.025 390.627 244.425 390.627C337.825 390.627 422.525 339.527 485.025 256.527C490.125 249.727 490.125 240.227 485.025 233.427C422.525 150.327 337.825 99.2266 244.425 99.2266ZM251.125 347.527C189.125 351.427 137.925 300.327 141.825 238.227C145.025 187.027 186.525 145.527 237.725 142.327C299.725 138.427 350.925 189.527 347.025 251.627C343.725 302.727 302.225 344.227 251.125 347.527ZM248.025 300.127C214.625 302.227 187.025 274.727 189.225 241.327C190.925 213.727 213.325 191.427 240.925 189.627C274.325 187.527 301.925 215.027 299.725 248.427C297.925 276.127 275.525 298.427 248.025 300.127Z" fill="url(#paint0_linear_267_655)"></path>
                </g>
            </g>
            <defs>
                <linearGradient id="paint0_linear_267_655" x1="63.4909" y1="99.8872" x2="401.684" y2="462.98" gradientUnits="userSpaceOnUse">
                    <stop offset="0.278846" stopColor="var(--greenLight-color)"></stop>
                    <stop offset="1" stopColor="var(--greenLight-color)"></stop>
                </linearGradient>
                <clipPath id="clip0_267_655">
                    <rect width="488.85" height="488.85" fill="white" transform="translate(0 0.5)"></rect>
                </clipPath>
            </defs>
        </svg>
    );
}
